module.exports = __webpack_public_path__ + "media/app/assets/hero-background-main2-85564e7e63ebcb7395544036de3dd31c.jpg";